// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

import RequestClient from "../nor/ts/RequestClient";
import Json from "../nor/ts/Json";
import SessionService from "./SessionService";

export class HttpService {

    public static async getJson (
        url      : string,
        headers ?: {[key: string]: string}
    ) : Promise<Json| undefined> {
        try {
            return await RequestClient.getJson(url, headers);
        } catch (err) {
            this._processStatusCode(err);
            throw err;
        }
    }

    public static async postJson (
        url      : string,
        data    ?: Json,
        headers ?: {[key: string]: string}
    ) : Promise<Json| undefined> {
        try {
            return await RequestClient.postJson(url, data, headers);
        } catch (err) {
            this._processStatusCode(err);
            throw err;
        }
    }

    public static async putJson (
        url      : string,
        data    ?: Json,
        headers ?: {[key: string]: string}
    ) : Promise<Json| undefined> {
        try {
            return await RequestClient.putJson(url, data, headers);
        } catch (err) {
            this._processStatusCode(err);
            throw err;
        }
    }

    public static async deleteJson (
        url      : string,
        headers ?: {[key: string]: string},
        data    ?: Json
    ) : Promise<Json| undefined> {
        try {
            return await RequestClient.deleteJson(url, headers, data);
        } catch (err) {
            this._processStatusCode(err);
            throw err;
        }
    }

    private static _processStatusCode (err : any) {

        const status = err?.getStatusCode();
        if (status === 403) {
            SessionService.logout();
        }

    }

}

export default HttpService;
